export const USER_COLUMNS = [
  {
    Header: "User Id",
    accessor: "UserId"
  },
  {
    Header: "Last Name",
    accessor: "LastName"
  },
  {
    Header: "First Name",
    accessor: "FirstName"
  },
  {
    Header: "Employee Type",
    accessor: "Employee.EmployeeType.CodeDescription"
  },
  {
    Header: "Roles",
    accessor: "UserGroupMemberships",
    Cell: ({ cell }) =>
      Array.isArray(cell.value)
        ? cell.value
            .map(ugm => ugm?.UserGroup?.GroupId)
            .sort()
            .join(", ")
        : ""
  },
  {
    Header: "Active",
    accessor: "Active"
  }
];

export const USER_GROUP_MEMBERSHIP_COLUMNS = [
  {
    Header: "RecId",
    accessor: "RecId",
    id: "RecId"
  },
  {
    Header: "GroupRecIdRef",
    accessor: "GroupRecIdRef",
    id: "GroupRecIdRef"
  },
  {
    Header: "UserRecIdRef",
    accessor: "UserRecIdRef",
    id: "UserRecIdRef"
  },
  {
    Header: "CompanyId",
    accessor: "CompanyId",
    id: "CompanyId"
  },
  {
    Header: "CreatedDateTime",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime"
  },
  {
    Header: "ModifiedDateTime",
    accessor: "ModifiedDateTime",
    id: "ModifiedDateTime"
  },
  {
    Header: "CreatedBy",
    accessor: "CreatedBy",
    id: "CreatedBy"
  },
  {
    Header: "ModifiedBy",
    accessor: "ModifiedBy",
    id: "ModifiedBy"
  }
];
